import client from './client';

export default class BaseApiService {
  protected client = client;
  protected basePath: string;

  constructor(basePath: string) {
    this.basePath = basePath;
  }

  protected getUrl(path: string): string {
    return `${this.basePath}${path}`;
  }

  // The shared client's response interceptor unwraps `response.data`, so
  // these resolve with the body itself (the axios types describe the raw
  // response, hence the casts).
  protected async get<T>(path: string, params?: object): Promise<T> {
    return (await this.client.get(this.getUrl(path), { params })) as unknown as T;
  }

  protected async post<T>(path: string, data?: object): Promise<T> {
    return (await this.client.post(this.getUrl(path), data)) as unknown as T;
  }

  protected async put<T>(path: string, data?: object): Promise<T> {
    return (await this.client.put(this.getUrl(path), data)) as unknown as T;
  }

  protected async delete<T>(path: string): Promise<T> {
    return (await this.client.delete(this.getUrl(path))) as unknown as T;
  }
}
